import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "c2318f88-da60-410e-bebe-35d6ca7a3e44",
    content: "Room acoustics ",
    options: {},
  },
  {
    id: "0405bd9f-7a0d-45cd-837e-4e1b7bfd46c3",
    content: "Building acoustics",
    options: {},
  },
  {
    id: "aa9add13-937d-40be-ae83-0c105eeccb8e",
    content: "Electro acoustics",
    options: {},
  },
  {
    id: "6fa62b26-d9e4-43bb-9dcb-68d8c3b94fc2",
    content: "Architectural acoustics",
    options: {},
  },
  {
    id: "4e133f6b-d38e-48b6-b25d-f90aabf134ff",
    content: "Bio acoustics",
    options: {},
  },
  {
    id: "3c987a35-23fa-4733-8ec0-00b000a10a97",
    content: "Theater acoustics",
    options: {},
  },
];

export const task: Task = {
  id: "79973e97-d5b9-45a9-a999-87fc932b04eb",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["c2318f88-da60-410e-bebe-35d6ca7a3e44"],
};
